import { render } from "./SendEmail.vue?vue&type=template&id=3f36d33f&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"

import "./SendEmail.vue?vue&type=style&index=0&id=3f36d33f&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f36d33f"]])

export default __exports__